<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 稽查管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>取证记录查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="商品名称" prop="productName">
                <el-input v-model="searchform.productName" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="条码" prop="qrcode" >
                <el-input v-model="searchform.qrcode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['forensics_select']"
              >搜索</el-button>
               <el-button
              v-permission="['forensics_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>取证记录</h4>
          <el-divider></el-divider>
          <el-table
            border
            @cell-click="danhang"
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
          <el-table-column prop="id" label="流水编号" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="accountName" label="稽查账号" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="employeeName" label="稽查人员" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productName" label="商品名称" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="商品条码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="specs" label="规格" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="上传时间" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="batchno"
              label="查看图片"
              min-width="120"
              show-overflow-tooltip
              fixed="right"
            >
              <template scope="scope">
                <el-button
                plain
                size="mini"
                @click="getimg(scope.row.imageName)"
                v-permission="['forensics_getimg']"
                >查看取证图片</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            title="取证图片"
            :visible.sync="dialogVisible"
            width="30%"
          >
            <div class="demo-image__preview">
              <el-image :src="src">
                <div slot="placeholder" class="image-slot">
                  加载中
                  <span class="dot">...</span>
                </div>
              </el-image>
            </div>
          </el-dialog>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { selectcorrect, selectimage } from "@/api/physical";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
  },
  data() {
    return {
      //基础数据
      dialogVisible: false,
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
        //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据

      searchform: {
        id: null,
        qrcode: null,
        datelist: [],
        screateTime: null,
        ecreateTime: null,
        productName: null,
        currPage: 1,
        pageSize: 10
      },
      src:
        process.env.VUE_APP_BASE_API_physical +
        "/api/out/mt/api/msc/selectimage?id=",
      srclist: [
        process.env.VUE_APP_BASE_API_physical +
          "/api/out/mt/api/msc/selectimage?id="
      ]
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      selectcorrect(obj).then(response => {
        this.tableData = response.data.list;
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 表格行单击
    danhang(row) {
      this.searchform.id = row.id;
      console.log(row);
    },
    // 获取详情图片
    getimg(imgurl) {
        // this.srclist[0] = imgurl;
      debugger
        if(imgurl){
          // console.log('imgurl1=====',decodeURIComponent(imgurl))
          debugger
          this.src =decodeURIComponent(imgurl) ;
        }else{
          this.src =''
        }

        this.dialogVisible = true;
    },
    //搜索事件
    search() {
      this.Tabledata({
        qrcode: this.searchform.qrcode,
        productName: this.searchform.productName,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        qrcode: this.searchform.qrcode,
        // screateTime: this.searchform.datelist[0] || null,
        // ecreateTime:this.searchform.datelist[1] || null,
        productName: this.searchform.productName,
        currPage: this.searchform.currPage,
        pageSize: this.searchform.pageSize
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
                  //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        qrcode: this.searchform.qrcode,
        productName: this.searchform.productName,
      };
      selectcorrect(obj).then(response => {
        this.tableDataDownload = response.data.list;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "流水编号",
            "稽查账号",
            "稽查人员",
            "商品名称",
            "商品条码",
            "规格",
            "备注",
            "上传时间",
          ];
          const filterVal = [
            "id",
            "accountName",
            "employeeName",
            "productName",
            "qrcode",
            "specs",
            "remark",
            "createTime",

          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>
